'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

___$insertStyle("/* \n* ink colors (with variations only for black and white)\n*/\n.accordion {\n  background: #ffffff;\n  border: none;\n  box-shadow: none;\n  margin-bottom: 5px;\n}\n.accordion__head {\n  padding: 0;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  margin-bottom: 10px;\n}\n.accordion__title {\n  font-size: 14px;\n  line-height: 22px;\n  font-weight: 500;\n  line-height: 1.5;\n  display: flex;\n  align-items: center;\n  color: #212529;\n}\n.accordion__title .icon {\n  font-size: 14px;\n  line-height: 22px;\n  font-weight: 500;\n  color: #1D66DD;\n}\n.accordion__body {\n  font-size: 14px;\n  line-height: 22px;\n  font-weight: 400;\n  padding: 0px 0px 0px 22px;\n  color: #212529;\n  line-height: 1.5;\n  flex: 1 1 auto;\n  overflow: hidden;\n}\n@media screen and (min-width: 1024px) {\n  .accordion__title {\n    font-size: 14px;\n    line-height: 22px;\n    font-weight: 500;\n  }\n  .accordion__body {\n    font-size: 14px;\n    line-height: 22px;\n    font-weight: 400;\n  }\n}\n.accordion__content {\n  max-height: 0;\n  transition: max-height 0.35s ease;\n}\n.accordion__content--show {\n  max-height: 500px !important;\n}");
//# sourceMappingURL=Accordion.scss.js.map
